<div class="detail-modal">
    <div class="consent-container-wrapper">
        <div class="row right">
            <i class="btn-close icon-edponline-Bop-071" *ngIf="data.showClose" data-modal="dismiss()"
            (click)="closeModal()"  aria-hidden="true"></i>
        </div>
        <div class="row">
            <div class="col-12">
                <h1 class="title"> {{ data.title | translate }} </h1>
                <ul ngbNav #nav="ngbNav" class="nav-tabs">
                    <li ngbNavItem *ngFor="let item of data.subSteps; let i = index">
                        <a ngbNavLink>{{ item.subTitle | translate }} </a>
                        <ng-template ngbNavContent>
                            <div class="description" [innerHTML]="item.message | translate"></div>
                        </ng-template>
                    </li>
                </ul>
                <div [ngbNavOutlet]="nav" class="mt-2"></div>
            </div>
        </div>
    </div>
</div>